import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";
import type { CmsEntry } from "@/lib/cms";

/**
 * Published website content, readable by anyone (SSR-safe).
 * Draft rows are excluded by the table's public read policy.
 */
export const getPublishedContent = createServerFn({ method: "GET" }).handler(async () => {
  const url =
    process.env["SUPABASE_URL"] ||
    process.env["VITE_SUPABASE_URL"] ||
    "https://rbcfewzpzoessczqpvef.supabase.co";
  const key =
    process.env["SUPABASE_PUBLISHABLE_KEY"] ||
    process.env["VITE_SUPABASE_PUBLISHABLE_KEY"] ||
    "sb_publishable_icN4AvnbuD9CUFL9UYByGg_oLcrrPEl";
  if (!url || !key) return { entries: [] as CmsEntry[] };

  const supabase = createClient<Database>(url, key, {
    auth: { persistSession: false, autoRefreshToken: false },
    global: {
      fetch: (input, init) => {
        const headers = new Headers(init?.headers);
        if (key.startsWith("sb_") && headers.get("Authorization") === `Bearer ${key}`) {
          headers.delete("Authorization");
        }
        headers.set("apikey", key);
        return fetch(input, { ...init, headers });
      },
    },
  });

  const { data, error } = await supabase
    .from("cms_entries")
    .select("id, kind, key, data, draft, status, sort_order, published_at, updated_at")
    .eq("status", "published")
    .order("kind")
    .order("sort_order");

  if (error) {
    console.error("cms: failed to load published content", error.message);
    return { entries: [] as CmsEntry[] };
  }

  return { entries: (data ?? []) as unknown as CmsEntry[] };
});
